import axiosInstance from '@/api/axiosInstance';
import {
  PathSettingsRequest,
  LearningPath,
} from '@/modules/learningCenter/features/LearningPaths/apiTypes';

/**
 * Update learning path settings (archive status, self-enrollment)
 * PUT /api/learning-paths/:id/settings
 * Requires ROLE_LEARNING_ADMIN or ROLE_SUPER_ADMIN
 *
 * Backend wraps the updated path in {data: {...}} (ApiController::createSuccessResponse),
 * same as GET /api/learning-paths — unwrap it so callers get the path itself.
 */
export const updateLearningPathSettings = async (
  id: number,
  data: PathSettingsRequest
): Promise<LearningPath> => {
  try {
    const response = await axiosInstance.put<{ data: LearningPath }>(
      `/api/learning-paths/${id}/settings`,
      data
    );
    return response.data.data;
  } catch (error) {
    console.error(`Error updating learning path settings ${id}:`, error);
    throw error;
  }
};
